import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=f4dda99a&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&id=f4dda99a&lang=css&scoped=true&"
import style1 from "./Search.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dda99a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4088215791/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4dda99a')) {
      api.createRecord('f4dda99a', component.options)
    } else {
      api.reload('f4dda99a', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=f4dda99a&scoped=true&", function () {
      api.rerender('f4dda99a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/containers/core/header/Search.vue"
export default component.exports